import { ComponentProps, FC } from 'react';
import styled from '@emotion/styled';

import { IngredientGroup, IngredientList } from '../components/ingredient-tab';
import { useBeautyService } from '../services/useBeautyService';

export const BeautyIngredientTabContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { ingredientDetail: detail } = useBeautyService();

  if (!detail) {
    return null;
  }

  const ingredientGroupList: ComponentProps<typeof IngredientGroup>[] = [
    {
      type: 'primary',
      groupList: detail.primary_ingredient_group,
    },
    {
      type: 'warning',
      groupList: detail.warning_ingredient_group,
    },
  ];

  return (
    <Root>
      {ingredientGroupList.map((item, index) => {
        if (item.groupList.length === 0) {
          return null;
        }
        return <IngredientGroup key={index} {...item} />;
      })}
      <IngredientList list={detail.ingredient_list} />
    </Root>
  );
};

const Root = styled.section`
  padding-bottom: 60px;
`;
